export default "__VITE_ASSET__Cta7Yvi4__"